<form role="form" *ngIf="infoVisitForm" [formGroup]="infoVisitForm">
  <label style="font-size: 17px; vertical-align: middle; padding: 8px;">Requiere visita</label>
  <input type="checkbox" formControlName="requireVisit" style="width: 30px; height: 30px; vertical-align: middle;" (change)="changeRequiereVisita()">
  <div class="row" *ngIf="requiereVisita==true">
    <div class="col-sm-12 col-md-6">
      <div class="entradas-de-texto-govco">
        <label for="input-basico-id">Acta visita <span class="required">*</span></label>
        <input type="text" id="input-basico-id"
               placeholder="Acta visita"
               formControlName="actVisit"
               [ngClass]="{'error': isTouchedField(infoVisitForm, 'actVisit')}"
        />
        <span
          class="error-texto-govco alert-entradas-de-texto-govco" id="actVisit-note" role="alert" aria-live="assertive">
                      {{ getErrorMessage('actVisit') }}
          </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-6">
      <div class="entradas-de-texto-govco">
        <label for="fecha-visita">Fecha visita <span class="required">*</span></label>
        <input type="date" id="fecha-visita"
               placeholder="Fecha de resolución de la licencia anterior"
               formControlName="dateVisit"
               (click)="verificarFecha()"
               [ngClass]="{'error': isTouchedField(infoVisitForm, 'dateVisit')}"
        />
        <span
          class="error-texto-govco alert-entradas-de-texto-govco" id="dateVisit-note" role="alert" aria-live="assertive">
                      {{ getErrorMessage('dateVisit') }}
          </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-12 mt-4">
      <label for="inputDocActaVisita" class="label-carga-de-archivo-govco">PDF Acta de visita
        <span class="required">*</span></label>
      <div class="input-group mt-2 mb-1">
        <input type="file" class="form-control input-file-custom" id="inputDocActaVisita"
               aria-describedby="inptFileLicAnterior" aria-label="Upload"
               formControlName="file"
               [ngClass]="{'error': isTouchedField(infoVisitForm, 'file')}"
               accept="application/pdf" (change)="checkSelectedFile($event)">
        <button class="btn btn-outline-secondary" type="button" id="inputDocDesc"
                *ngIf="documentActual!= null"
                (click)="removeFileAdded()">
          <span class="govco-trash-alt"></span>
        </button>
        <span
          class="error-texto-govco alert-entradas-de-texto-govco" id="file-note" role="alert" aria-live="assertive">
                      {{ getErrorMessage('file') }}
          </span>
      </div>
      <span class="text-validation-carga-de-archivo-govco"><small>Únicamente archivo(s) en formato .pdf.</small></span>
      <div class="d-flex" style="width: 100%;">
        <div class="col-md-6 col-lg-6 col-xxl-6 col-sm-12 mt-3">
          <div class="d-flex mx-auto" *ngIf="documentActual != null">
            <img (click)="visorPdf()" [src]="urlImageView" class="img-fluid icon" alt="pdf_letf">
            <img (click)="viewInOtherPagePdf()" [src]="urlDowmloadpdf"
                 class="img-fluid icon" alt="pdf_image">
          </div>
        </div>
        <div class="col-md-6 col-lg-6 col-xxl-6 col-sm-12 mt-3" *ngIf="documentActual != null">
          <div class=" border">
            <div style="display: flex;align-items: center;justify-content: center;">
              <iframe title="iframepdf" id="iFrameVisit" width="800" height="500" src="" type="application/pdf"></iframe>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</form>
